import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import Store from "./Reducers/Store";
import { WithAxios } from "./WithAxios";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Store>
    <WithAxios>
      <BrowserRouter basename="/">
        <App />
      </BrowserRouter>
    </WithAxios>
  </Store>
);
